module.exports = __webpack_public_path__ + "media/images/rbp_welcome-3c5be6ec7ddab0c188af8738e5e49d86.png";